// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import App from './App'
import router from './router'
import BootstrapVue from 'bootstrap-vue'
import carousel from 'v-owl-carousel'
import VueProgressBar from 'vue-progressbar'
import store from './store'
import VueElementLoading from 'vue-element-loading'

// css and scss files include
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import './assets/css/font-awesome.min.css'
// import './assets/index.scss'

// remove below file for change color
// import './assets/css/color/color-2.css'

Vue.component('VueElementLoading', VueElementLoading)
Vue.use(BootstrapVue)
Vue.use(VueAxios, axios)
Vue.component('carousel', carousel)
Vue.config.productionTip = false
var VueScrollTo = require('vue-scrollto')
Vue.use(VueScrollTo)

const options = {
  color: '#7DEADF',
  failedColor: '#7DEADF',
  thickness: '4px',
  transition: {
    speed: '0.5s',
    opacity: '0.10s',
    termination: 300,
  },
  autoRevert: true,
  location: 'top',
  inverse: false,
}
Vue.use(VueProgressBar, options)

export const vues = new Vue()
/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>',
})

// new Vue({
//   el: '#app',
//   store,
//   router,
//   components: { App },
//   template: '<App/>',
// })



// WEBPACK FOOTER //
// ./src/main.js